import { Component, Input } from '@angular/core';
import { AdditionalProductsSummaryPoint, IERechnungsInfo, TextNodeType } from '@mwe/models';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

import { NewBankAccountInfoTextsComponent } from '../../bank/new-bank-account-info-texts/new-bank-account-info-texts.component';
import { HeadlineComponent } from '../../headline/headline.component';
import { InfoboxComponent } from '../../infobox/infobox.component';
import { SafeHtmlPipe } from '@mwe/ui/pipes';

@Component({
  selector: 'mwe-products-summary-invoice-old',
  templateUrl: './products-summary-invoice-old.component.html',
  imports: [TranslateDirective, NewBankAccountInfoTextsComponent, TranslatePipe, HeadlineComponent, InfoboxComponent, SafeHtmlPipe],
})
export class ProductsSummaryInvoiceOldComponent {
  @Input() isPaymentInfoVisible;
  @Input() personalBillingTitle: string;
  @Input() eRechnungInfo: IERechnungsInfo;
  @Input() paymentIcon: string;
  @Input() paymentText: string;
  @Input() formattedAddress: string;
  @Input() contactDataEmailAddress: string;
  @Input() additionalBulletPoints: AdditionalProductsSummaryPoint[];
  @Input() areBankAccountInfoTextsVisible: boolean;
  @Input() productCategories: string[];
  @Input() invoiceInfoAlertMessage: string;
  @Input() paymentDataLabelClass?: string;
  @Input() eBillingLabelClass?: string;
  @Input() contactDataEmailAddressLabelClass?: string;
  @Input() summaryBillingTitleText?: string = 'summary.eBilling';
  @Input() billingAddressTitleText?: string = null;
  @Input() shippingEmailTitleText?: string = null;
  @Input() infoTextCardLabel: string;
  @Input() hasSpotTariff = false;
  @Input() headlineNodeType: TextNodeType = 'h3';
}
